export const SOCIAL_LINKS = {
  discordInvite: "https://discord.gg/Qb6RcjXq6z",
  discordBotInvite:
    "https://discord.com/oauth2/authorize?client_id=1532050240641831103&scope=bot+applications.commands&permissions=274877991936",
  githubRepo: "https://github.com/openriftapp/openrift",
  extensionDownload:
    "https://github.com/openriftapp/openrift/releases/download/extension-updates/openrift-companion.xpi",
  githubIssues: "https://github.com/openriftapp/openrift/issues",
  githubNewIssue: "https://github.com/openriftapp/openrift/issues/new/choose",
  githubCommits: "https://github.com/openriftapp/openrift/commits/main/",
} as const;
